

































import { Vue, Component, Provide, Prop, Watch } from "vue-property-decorator";
import { Environment } from "../../environments/environment";

@Component({})
export default class TabPageExp extends Vue {

  @Provide()
  public styleLeft: number = 0;

  @Provide()
  public actions: any[] = [
    { text: "app.tabpage.closeall", value: "closeAll" },
    { text: "app.tabpage.closeother", value: "closeOther" }
  ];

  /**
   * 关闭tab页方法
   */
  public handlerClose(item: any){
    this.doTagAction(item.value);
  }

  public editableTabsValue: any = ""; //tabs页绑定值

  @Watch("$route")
  public onRouteChange(newVal: any) {
    this.moveToView(newVal);
    this.$emit("change", newVal);
  }

  public created() {
    Vue.prototype.$tabPageExp = this;
  }

  public getCaption(caption: any, info: any, parameters: any, index: any): any {
    let queryParams: any = {}
    const curPath: any = this.$store.state.pageTagList[index].fullPath
    this.$viewTool.formatRouteParams({},{fullPath: curPath},{},queryParams);
    // 委托客户信区分修改\查看页签
    if(caption.includes('bdentrustedcustomerfile.views.usr2gridview.caption') || caption.includes('bdentrustedcustomerfile.views.usr2editview.caption') ){
      return '销售运营商信息'
    }
    if(caption.includes('bdentrustedcustomerfile.views.usr3editview.caption') ){
      return '查看销售运营商信息'
    }
    if(caption.includes('woworkorder.views.tripartiteview.caption') ){
      return '销售运营商工单'
    }
    if(caption.includes('woworkorder.views.usr16editview.caption') ){
      return '导入工单'
    }
    let number: any = ''
    const isServiceEdit1: any = /\/csswkd\/null\/(woworkorders|bdcustomers).*\/(internalpendingdate|usr3editview|usr5editview)/.test(curPath)
    if (queryParams && queryParams.number && isServiceEdit1) {
      number = queryParams.number
    }

    const isServiceEdit2:any=/\/csswkd\/null\/(woworkorders|wosmvisittasks|bdcustomers).*\/(usr7editview|usr8editview|usr9editview)/.test(curPath)
    if(queryParams && queryParams.task_number && isServiceEdit2){
      number = queryParams.task_number
    }

    const isServiceEdit3:any=/\/csswkd\/null\/(wosmabnormals).*\/(abnormaleditview|editview_approval)/.test(curPath)
    if(queryParams && queryParams.abnormal_no && isServiceEdit3){
      number = queryParams.abnormal_no
    }
    const isServiceEdit4:any=/\/csswkd\/null\/(wosmguarantees).*\/(usr2editview)/.test(curPath)
    if(queryParams && queryParams.guarantee_code && isServiceEdit4){
      number = queryParams.guarantee_code
    }

    const isServiceEdit5:any=/\/csswkd\/null\/(wosmstimulates).*\/(usr4editview)/.test(curPath)
    if(queryParams && queryParams.stimulate_number && isServiceEdit5){
      number = queryParams.stimulate_number
    }

    const isServiceEdit6:any=/\/csswkd\/null\/(wosmstimulates).*\/(appealreadeditview)/.test(curPath)
    if(queryParams && queryParams.appeal_number && isServiceEdit6){
      number = queryParams.appeal_number
    }

    const isServiceEdit7:any=/\/csswkd\/null\/(wosmsurcharges).*\/(examineeditview|otherskipeditview)/.test(curPath)
    if(queryParams && queryParams.apply_number && isServiceEdit7){
      number = queryParams.apply_number
    }

    const isServiceEdit8:any=/\/csswkd\/null\/(wosmclaimsinfobasics).*\/(usr2editview|editview_approval)/.test(curPath)
    if(queryParams && queryParams.claim_no && isServiceEdit8){
      number = queryParams.claim_no
    }

    const isServiceEdit9:any=/\/csswkd\/null\/(wosmrevieweds).*\/(usr2editview|editview|auditeditview)/.test(curPath)
    if(queryParams && queryParams.reviewed_number && isServiceEdit9){
      number = queryParams.reviewed_number
    }

    const isServiceEdit10:any=/\/csssp\/null\/(spreturns).*\/(editview|usr2editview)/.test(curPath)
    if(queryParams && queryParams.return_order_no && isServiceEdit10){
      number = queryParams.return_order_no
    }

    const isServiceEdit11:any=/\/csssp\/null\/(spdestructions).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.destruction_order_no && isServiceEdit11){
      number = queryParams.destruction_order_no
    }

    const isServiceEdit12:any=/\/csssp\/null\/(sppurchases).*\/(spbookingeditview)/.test(curPath)
    if(queryParams && queryParams.booking_order_no && isServiceEdit12){
      number = queryParams.booking_order_no
    }

    const isServiceEdit13:any=/\/csssp\/null\/(sppurchases).*\/(sppurchaseeditview|spagenteditview|spallocationeditview|spreserveseditview)/.test(curPath)
    if(queryParams && queryParams.order_no && isServiceEdit13){
      number = queryParams.order_no
    }

    const isServiceEdit14:any=/\/csssp\/null\/(spengineerreceives).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.receive_order_no && isServiceEdit14){
      number = queryParams.receive_order_no
    }

    const isServiceEdit15:any=/\/csssp\/null\/(spengineerreturns).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.return_order_no && isServiceEdit15){
      number = queryParams.return_order_no
    }

    const isServiceEdit16:any=/\/csssp\/null\/(sppurchaseinbounds).*\/(sppurchaseinboundeditview)/.test(curPath)
    if(queryParams && queryParams.inbound_order_no && isServiceEdit16){
      number = queryParams.inbound_order_no
    }

    const isServiceEdit17:any=/\/csssp\/null\/(spsalesoutbounds).*\/(spsalesoutboundeditview)/.test(curPath)
    if(queryParams && queryParams.sales_order_no && isServiceEdit17){
      number = queryParams.sales_order_no
    }
    const isServiceEdit18:any=/\/csswkd\/null\/(channelfeedbackrecords).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.feedback_no && isServiceEdit18){
      number = queryParams.feedback_no
    }
    const isServiceEdit19:any=/\/csssp\/(spcustomizedit).*\/(spcustomizedit)/.test(curPath)
    if(queryParams && queryParams.order_no && isServiceEdit19){
      number = queryParams.order_no
    }
    const isServiceEdit20:any=/\/csswkd\/null\/(wosmvisitredeems).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.task_number && isServiceEdit20){
      number = queryParams.task_number
    }

    const isServiceEdit21:any=/\/csswkd\/null\/(wosmclaimsinfobasics).*\/(gridview|editview)/.test(curPath)
    if(isServiceEdit21){
      return '索赔单管理'
    }
    const isServiceEdit22:any=/\/csswkd\/null\/(wosmconfigures).*\/(usr2gridview|createclearingeditview)/.test(curPath)
    if(isServiceEdit22){
      return '服务商结算标准配置'
    }
    const isServiceEdit23:any=/\/cssbd\/null\/(bdsaleorders).*\/(editview)/.test(curPath)
    if(queryParams && queryParams.mainsaleorderno && isServiceEdit23){
      number = queryParams.mainsaleorderno
    }
    const isCPReturnCheck:any=/\/csswkd\/null\/(woreturngoods).*\/checkformview/.test(curPath)
    if(queryParams && queryParams.order_code && isCPReturnCheck){
      number = queryParams.order_code
    }

    const isCPDestroyCheck:any=/\/csswkd\/null\/(wodestroygoods).*\/checkformview/.test(curPath)
    if(queryParams && queryParams.order_code && isCPDestroyCheck){
      number = queryParams.order_code
    }
    return number
      ? `${this.$t(caption)} ${number}`
      : info && !Object.is(info, "")
        ? `${this.$t(caption)} - ${this.$t(info)}`
        : `${this.$t(caption)}`;
  }

  /**
   * 向左移动
   *
   * @memberof TabPageExp
   */
  public leftMove() {
    const scrollBody: any = this.$refs.scrollBody;
    const scrollChild: any = this.$refs.scrollChild;
    if (
      scrollBody &&
      scrollChild &&
      scrollChild.offsetWidth > scrollBody.offsetWidth
    ) {
      if (
        scrollChild.offsetWidth - scrollBody.offsetWidth + this.styleLeft >
        100
      ) {
        this.styleLeft -= 100;
      } else {
        this.styleLeft = scrollBody.offsetWidth - scrollChild.offsetWidth;
      }
    }
  }

  /**
   * 向右移动
   *
   * @memberof TabPageExp
   */
  public rightMove() {
    if (this.styleLeft < 0) {
      if (this.styleLeft + 100 > 0) {
        this.styleLeft = 0;
      } else {
        this.styleLeft += 100;
      }
    }
  }

  /**
   * 是否选中
   *
   * @param {(string | number)} index
   * @returns
   * @memberof TabPageExp
   */
  public isActive(index: string | number) {
    const page = this.$store.state.pageTagList[index];
    if (Object.is(page.fullPath, this.$route.fullPath)) {
      return true;
    }
    return false;
  }

  /**
   * 关闭
   *
   * @param {*} event
   * @param {*} name
   * @memberof TabPageExp
   */
  public onClose(name: any) {
    const page = this.$store.getters.getPage(name);
    if (!page) {
      this.$store.commit("deletePage", name);
      this.gotoPage();
    }
    const appview = this.$store.getters["viewaction/getAppView"](page.viewtag);
    if (appview && appview.viewdatachange) {
      const title: any = this.$t("app.tabpage.sureclosetip.title");
      const content: any = this.$t("app.tabpage.sureclosetip.content");
      this.$Modal.confirm({
        title: title,
        content: content,
        onOk: () => {
          // this.postToParent(page.fullPath);
          this.$store.commit("deletePage", name);
          this.gotoPage(page.fullPath);
        },
        onCancel: () => {}
      });
    } else {
      // this.postToParent(page.fullPath);
      this.$store.commit("deletePage", name);
      this.gotoPage(page.fullPath);
    }
  }

  public postToParent(url: any) {
    this.$emit('closeTab', url)
  }
  /**
   * 是否显示关闭
   *
   * @returns
   * @memberof TabPageExp
   */
  public isClose() {
    const pageTagList = this.$store.state.pageTagList;
    if (pageTagList.length > 1) {
      return true;
    }
    return false;
  }

  /**
   * 切换分页
   *
   * @param {*} index
   * @memberof TabPageExp
   */
  public changePage(tab: any, event: any) {
    this.editableTabsValue = tab.index;
    this.$store.commit("setCurPage", tab.index);
    this.gotoPage();
    // this.$emit('pagePath', this.$route.fullPath)
  }

  /**
   * 跳转页面
   *
   * @returns
   * @memberof TabPageExp
   */
  public gotoPage(movedUrl?: any) {
    const removedUrlList: any = Array.isArray(movedUrl)
                                ? movedUrl
                                : movedUrl
                                  ? [movedUrl]
                                  : []
    const length = this.$store.state.historyPathList.length;
    if (length > 0) {
      const path = this.$store.state.historyPathList[length - 1];
      if (Object.is(path, this.$route.fullPath)) {
        return;
      }
      const index = this.$store.state.pageTagList.findIndex((page: any) =>
        Object.is(page.fullPath, path)
      );
      if (index >= 0) {
        const page = this.$store.state.pageTagList[index];
        this.$router.push({
          path: page.path,
          params: page.params,
          query: page.query
        });
        const emitParams: any = {
          pushTo: page.fullPath,
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      }
    } else {
      let path: string | null = window.sessionStorage.getItem(
        Environment.AppName
      );
      if (path && this.isSysRootPath(path)) {
        this.$router.push({ path: path });
        const emitParams: any = {
          pushTo: path,
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      } else {
        this.$router.push("/");
        const emitParams: any = {
          pushTo: '/',
          removedUrlList: removedUrlList
        }
        this.$emit('pagePath', emitParams)
      }
    }
  }

  public isSysRootPath(path: any) {
    let urlPrefix: any = ['cssbd', 'csswkd', 'csssp', '/index']
    const isRootPath: any = urlPrefix.filter((itemPath: any) => {
      const slash: any = !itemPath.includes('/') ? '/' : ''
      return slash + itemPath === path
    }).length > 0
    return isRootPath
  }

  /**
   * 设置当前页标题
   *
   * @param {*} caption
   * @memberof TabPageExp
   */
  public setCurPageCaption(caption: string, title: any, info: string) {
    if (this.$route.meta && !Object.is(this.$t(this.$route.meta.caption), caption)) {
      return;
    }
    this.$store.commit("setCurPageCaption", {
      route: this.$route,
      caption: title,
      info: info
    });
    setTimeout(() => {
      this.moveToView(this.$route);
    }, 1);
  }

  /**
   * 移动至指定页面标签
   *
   * @param {*} to
   * @memberof TabPageExp
   */
  /**
   * 移动至指定页面标签
   *
   * @param {*} to
   * @memberof TabPageExp
   */
  public moveToView(to: any) {
    let that: any = this;
    const pages: any[] = this.$store.state.pageTagList;
    let leftWidth: number = 0;
    this.$nextTick(() => {
      let _index: any = "";
      pages.forEach((page, index) => {
        if (Object.is(page.path, to.path)) {
          _index = index + "";
        }
      });
      if (_index !== "") {
        that.editableTabsValue = _index + "";
      }
    });
  }

  /**
   * 设置左侧边距
   *
   * @param {{ offsetWidth: number; }} tag
   * @param {number} leftWidth
   * @memberof TabPageExp
   */
  public setLeft(tag: { offsetWidth: number }, leftWidth: number) {
    if (tag) {
      const scrollBody: any = this.$refs.scrollBody;
      if (leftWidth < -this.styleLeft) {
        this.styleLeft = -leftWidth;
      } else if (
        leftWidth + tag.offsetWidth >
        scrollBody.offsetWidth - this.styleLeft
      ) {
        this.styleLeft -=
          leftWidth +
          tag.offsetWidth -
          (scrollBody.offsetWidth - this.styleLeft);
      }
    }
  }

  /**
   * 执行行为操作
   *
   * @param {string} name
   * @memberof TabPageExp
   */
  public doTagAction(name: string) {
    if (Object.is(name, "closeAll")) {
      const removedUrlList: any = this.$store.state.historyPathList
      this.$store.commit("removeAllPage");
      this.gotoPage(removedUrlList);
    } else if (Object.is(name, "closeOther")) {
      const emitParams: any = {
        pushTo: this.$route.fullPath,
        removedUrlList: this.$store.state.historyPathList.filter((path: any) => path !== this.$route.fullPath)
      }
      this.$store.commit("removeOtherPage");
      this.moveToView(this.$route);
      this.$emit('pagePath', emitParams)
    }
  }
}
